import * as React from 'react';
import { cn } from '@/lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  inputSize?: 'sm' | 'md' | 'lg';
  mono?: boolean;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, inputSize = 'md', mono, type = 'text', ...props }, ref) => {
    const h = { sm: 'h-8', md: 'h-10', lg: 'h-12' }[inputSize];
    return (
      <input
        ref={ref}
        type={type}
        className={cn(
          'w-full rounded-md border border-line bg-paper px-3 text-base text-ink outline-none placeholder:text-muted-2 focus-visible:border-line-2 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-background disabled:opacity-50 md:text-sm',
          h,
          mono && 'font-mono',
          className,
        )}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';
